document.addEventListener("DOMContentLoaded", () => {
  if (matchMedia("(max-width: 989px)").matches) return;

  document.querySelectorAll("header-menu details").forEach((d) => {
    const close = () => { d.open = false; };

    d.addEventListener("mouseenter", () => { d.open = true; });
    d.addEventListener("mouseleave", close);

    d.querySelectorAll("a").forEach((a) => a.addEventListener("focus", () => { d.open = true; }));
    d.querySelectorAll("a").forEach((a) => a.addEventListener("blur", close));
  });
});
